import { render } from "./PrintGoals.vue?vue&type=template&id=8c2296ba&scoped=true"
import script from "./PrintGoals.vue?vue&type=script&lang=js"
export * from "./PrintGoals.vue?vue&type=script&lang=js"

import "./PrintGoals.vue?vue&type=style&index=0&id=8c2296ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2296ba"]])

export default __exports__